const nullToEmptyString = (obj, exc = []) => {
  if (!obj) {
    return obj;
  }

  return Object.keys(obj).reduce((acc, curr) => {
    if (obj[curr] == null && !exc.includes(curr)) {
      acc[curr] = "";
    } else {
      acc[curr] = obj[curr];
    }

    return acc;
  }, {});
};

export default nullToEmptyString;
